/**
 * Created by USER on 18/5/18.
 */
import {
  CHANGEBAR_STATE,
  CHANGE_LANGUAGE,
  CHANGE_OFFSETWIDTH
} from '../actions/headerbar_action';

const initState = {
  appbarState: 'home_page',
  language: 'zh',
  offsetWidth: null
};

export default function appBarReducer(state = initState, action) {
  switch (action.type) {
    case CHANGEBAR_STATE:
      return Object.assign({}, state, { appbarState: action.data});
    case CHANGE_LANGUAGE:
      return Object.assign({}, state, { language: action.data});
    case CHANGE_OFFSETWIDTH:
      return Object.assign({}, state, { offsetWidth: action.data});
    default:
      return state;
  }
}
